import { create } from "zustand";
import { WLConfig } from "../../../Common/models/config";

interface ConfigState {
  wlConfig: null | WLConfig;
  setWlConfig: (state: WLConfig) => void;

  globalRefreshStamp: number;
  setGlobalRefreshStamp: (state: number) => void;

  resetStore: () => void;
}

const useWLConfigStore = create<ConfigState>((set) => ({
  wlConfig: null,
  setWlConfig: (config) => set({ wlConfig: config }),

  globalRefreshStamp: new Date().valueOf(),
  setGlobalRefreshStamp: (globalRefreshStamp) => set({ globalRefreshStamp }),

  resetStore: () => {
    return set({
      wlConfig: null,
    });
  },
}));

export default useWLConfigStore;
